import { trans } from '@codebuild/cookie-jar/libs/translation/trans';
import * as React from 'react';
import { Subscribable } from '../../../libs/subscribable';
import { GaugeWrapper } from '../../gauge-chart/gauge-wrapper';
import { UserInterface } from '../../share/interfaces/user.interface';
import { PurchaseDocument } from '../../share/manage-access';
import { CompatibilityBox } from './extras/compatibility-box';

export interface CompatibilityBoxProps {
    user?: UserInterface;
    purchases: PurchaseDocument | null;
}

export class BehaviourCompatibilityBox extends Subscribable<CompatibilityBoxProps, any> {
    public async componentDidMount() {
        this.checkIfPurchased();
    }

    public componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (prevProps.user !== this.props.user) {
            this.checkIfPurchased();
        }
        if (prevProps.purchases !== this.props.purchases) {
            this.checkIfPurchased();
        }
    }

    public renderGauge(compatibility: number, isAnimated: boolean) {
        if (isAnimated) {
            return <div className={'w-100 position-center'}>
                <GaugeWrapper
                    isAnimated={true}
                    value={compatibility}
                    width={150}
                    height={150}
                />
            </div>;
        }

        return <div className={'w-100 position-center'}>
            <GaugeWrapper
                isAnimated={false}
                value={compatibility}
                width={150}
                height={150}
            />
        </div>;
    }

    public checkIfPurchased() {
        return !!this.props.purchases?.behaviouralCompatibility?.find((i: string) => i === this.props.user?._id);
    }

    public checkIfCalculated() {
        return !!this.props.purchases?.behaviouralCharts?.find((i: string) => i === this.props.user?._id);
    }

    public render() {
        return <CompatibilityBox
            isPurchased={this.checkIfPurchased()}
            isCalculated={this.checkIfCalculated()}
            userId={this.props.user?._id || ''}
            viewedUser={this.props.user}
            analysisType={'behaviouralQuestionnaire'}
            tabName={'behaviour'}
            boxTitle={trans('account.data.behavioural.questionnaire')}
            type={'behavioural-chart'}
            calcType={'behavioural-compatibility'}
            renderGaugeContent={(compatibility, isAnimated) => this.renderGauge(compatibility, isAnimated)}
        />;
    }
}
